import { render, staticRenderFns } from "./SalesButton.vue?vue&type=template&id=ace5fc96&scoped=true"
import script from "./SalesButton.vue?vue&type=script&lang=js"
export * from "./SalesButton.vue?vue&type=script&lang=js"
import style0 from "./SalesButton.vue?vue&type=style&index=0&id=ace5fc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace5fc96",
  null
  
)

export default component.exports